import { useState } from 'react';
import iconFacebook from '../../assets/images/facebook.png';
import iconPrint from '../../assets/images/print.png';
import iconTelegram from '../../assets/images/telegram.png';
import iconTwitter from '../../assets/images/twitter.png';
import iconWhatsapp from '../../assets/images/whatsapp.png';
import { useAuth } from '../../hooks/useAuth';
import { api } from '../../server/api';
import { ModalPosterPrint } from '../ModalPosterPrint';
import styles from './style.module.css';

interface IDataAction {
  action?: any;
  posterDownload?: boolean;
  actionImagesBase64?: any;
  cartazCover?: any;
}

export function ShareButton({
  action,
  posterDownload,
  cartazCover,
  actionImagesBase64,
}: IDataAction) {
  const { client, player } = useAuth();
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

  const toggleModalIsOpen = () => {
    setModalIsOpen(!modalIsOpen);
  };

  const registerPlayerOnAction = async (actionId: string) => {
    try {
      const parameters = {
        searchFunctionality: 'registerPlayerInAction',
        userType: 'player',
        actionId,
        clientId: client.id,
      };

      await api.post(`/actions`, parameters);
    } catch (error) {
      console.log('error registerPlayerOnAction-->', error);
    }
  };

  const increaseShareChannelCount = async (
    channel: string,
    actionId: string
  ) => {
    try {
      const parameters = {
        updateFunctionality: 'increaseShareChannelCount',
        userType: 'player',
        actionId,
        playerId: player.id,
        channel,
        clientId: player.clientId,
      };

      await api.post('/update', parameters);
    } catch (error) {
      console.log('error increaseShareChannelCount-->', error);
    }
  };

  const fbShare = async () => {
    let message =
      action &&
      action.conversionType &&
      action.conversionType === 'membergetmember'
        ? `${player && player.name} ${'tem uma convite para você!'}`
        : `${player && player.name} ${
            client.sendMessageClient
              ? client.sendMessageClient
              : 'tem um convite para você!'
          }`;

    message += ` ${action && action.actionTitle}`;

    window.open(
      `https://facebook.com/sharer/sharer.php?u=${
        action && action.shareUrl
      }&quote=${message}`,
      'pop',
      'width=600, height=400, scrollbars=no'
    );
    action && (await registerPlayerOnAction(action.id));
    action && (await increaseShareChannelCount('facebook', action.id));
  };

  const whatsappShare = async () => {
    const textMgm = 'tem um convite para você.';
    // console.log(player);

    let message =
      action &&
      action.conversionType &&
      action.conversionType === 'membergetmember'
        ? // ? `${player && player.name} ${'tem uma convite para você!'}`
          `${player && player.name} ${textMgm}`
        : `${player && player.name} ${
            client.sendMessageClient ? client.sendMessageClient : textMgm
          }`;

    message += ` ${action && action.actionTitle}`;

    window.open(
      `https://api.whatsapp.com/send?text=${message} - ${
        action && action.shareUrl
      }`,
      '_blank'
    );

    action && (await registerPlayerOnAction(action.id));
    action && (await increaseShareChannelCount('whatsapp', action.id));
  };

  const twitterShare = async () => {
    const message =
      action &&
      encodeURIComponent(
        `${' '}${player.name}${' '}${
          action && action.conversionType === 'membergetmember'
            ? 'tem um convite para você.'
            : client.sendMessageClient
              ? client.sendMessageClient
              : 'tem um indicação para você!'
          // } ${action.shareUrl}`
        } `
      );

    action &&
      window.open(
        `https://twitter.com/share?text=${message}&url=${action.shareUrl}`,
        'pop',
        'width=600, height=400, scrollbars=no'
      );

    action && (await registerPlayerOnAction(action.id));
    action && (await increaseShareChannelCount('twitter', action.id));
  };

  const telegramShare = async () => {
    const textMgm = 'tem um convite para você.';

    action &&
      window.open(
        `https://telegram.me/share/url?url=${encodeURIComponent(
          action.shareUrl
        )}&text=${' ' + '-' + ' ' + player.name} ${
          action.conversionType === 'membergetmember'
            ? textMgm
            : ' ' + client && client.sendMessageClient
        }`,
        '_blank',
        'width=600, height=400, scrollbars=no'
      );

    action && (await registerPlayerOnAction(action.id));
    action && (await increaseShareChannelCount('telegram', action.id));
  };

  return (
    <>
      <div className={`${styles.buttonsWrapper} gap-3`}>
        <button onClick={fbShare} className={styles.btnShare}>
          <img src={iconFacebook} alt={iconFacebook} />
        </button>
        <button onClick={twitterShare} className={styles.btnShare}>
          <img src={iconTwitter} alt={iconTwitter} />
        </button>
        <button onClick={whatsappShare} className={styles.btnShare}>
          <img src={iconWhatsapp} alt={iconWhatsapp} />
        </button>
        <button onClick={telegramShare} className={styles.btnShare}>
          <img src={iconTelegram} alt={iconTelegram} />
        </button>
        {posterDownload && action.showPoster && (
          <button
            className={styles.btnShare}
            onClick={() => toggleModalIsOpen()}
          >
            <img src={iconPrint} alt={iconPrint} />
          </button>
        )}
      </div>
      {modalIsOpen && (
        <ModalPosterPrint
          modalIsOpen={modalIsOpen}
          closeModal={toggleModalIsOpen}
          clientPrimaryColor={client && client.primaryColor}
          playerName={player && player.name}
          action={action}
          shareUrl={action && action.shareUrl}
          actionImagesBase64={actionImagesBase64}
          cartazCover={cartazCover}
        />
      )}
    </>
  );
}
